import Vue from 'vue'
import CryptoJS from 'crypto-js'
export default {
    //加密
    encrypt(word){ 
        var key = CryptoJS.enc.Utf8.parse("8yt4poM8bEDU8CxW");//十六位十六进制数作为秘钥
        var iv = CryptoJS.enc.Utf8.parse('8yt4poM8bEDU8CxW');//十六位十六进制数作为秘钥偏移量
        var srcs = CryptoJS.enc.Utf8.parse(word);
        var encrypted = CryptoJS.AES.encrypt(srcs, key, {
            iv:iv,
            mode:CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    },
    //解密
}


// WEBPACK FOOTER //
// ./src/util/aes.js